<template>
	<Card>
		<template #header>
			<h3>{{ $t('distributor.action.report_payment_amount') }}</h3>
		</template>
		<template #content>
			<div class="card-item">
				<div class="card-item-label">{{ $t('distributor.order.real_amount') }}</div>
				<div class="card-item-value">
					<cube-input
						type="number"
						v-model="form_params.payment_amount"
						:placeholder="$t('distributor.order.real_amount_placeholder')"
					></cube-input>
				</div>
			</div>
			<div class="card-item">
				<div class="card-item-label">{{ $t('distributor.order.upload_menu') }}</div>
				<div class="card-item-value">
					<cube-upload
						ref="upload"
						@file-submitted="uploadImage"
						v-model="images"
						:auto="false"
					></cube-upload>
				</div>
			</div>
		</template>
		<template #footer>
			<div class="operators">
				<mt-button class="common-btn danger" @click.native="cancel()">
					{{ $t('general.cancel') }}
				</mt-button>
				<mt-button
					class="common-btn primary"
					@click.native="submit()"
					:disabled="$v.form_params.$invalid || $v.images.$invalid || submitDisabled"
				>
					{{ $t('general.submit') }}
				</mt-button>
			</div>
		</template>
	</Card>
</template>
<script>
import Card from '@/components/basic/card'
import Compressor from 'compressorjs'
import { required, integer } from 'vuelidate/lib/validators'
import { reportPaymentAmount } from '@/api/distributorOrder'

export default {
	name: 'ReportPaymentAmount',
	props: ['order_id'],
	components: { Card },
	validations: {
		form_params: {
			order_id: {
				required,
				integer
			},
			payment_amount: {
				required,
				integer
			},
		},
		images: {
			required,
			notEmpty: function (val) {
				try {
					return val && val.length > 0
				} catch (err) {
					return false
				}
			}
		}
	},
	data() {
		return {
			submitDisabled: false,
			images: [],
			form_params: {
				order_id: undefined,
				payment_amount: undefined,
				images: []
			}
		}
	},
	watch: {
		order_id: function (val) {
			if (val) {
				this.initialFormParams({ order_id: val })
			}
		}
	},
	methods: {
		initialFormParams(params) {
			this.form_params = Object.assign(
				{},
				{
					order_id: undefined,
					payment_amount: undefined,
					images: []
				},
				params
			)
		},
		cancel() {
			this.$emit('cancel')
		},
		uploadImage() {
			const _this = this;
			let length = this.images.length;
			for (let i = 0; i < length; i ++) {
				new Compressor(this.images[i].file, {
					quality: 0.6,
					maxHeight: 1000,
					maxWidth: 1000,
					success(result) {
						_this.form_params.images[i] = {
							file : result
						}
					},
					error(err) {
						console.error(err)
					}
				})
			}
		},
		async submit() {
			this.submitDisabled = true;
			try {
				await reportPaymentAmount(this.form_params)
				this.$emit('submit')
				this.$alert.success(this.$t('distributor.order.report_successfully'))
			} catch (err) {
				console.error('Error', err)
				this.$alert.error(this.$t('general.error') + ': ' + err.message)
			}
			this.submitDisabled = false;
		}
	}
}
</script>

<style>
</style>
